/*
 * @Author: Daokai Huo
 * @Date: 2021-09-29 11:22:54
 * @LastEditTime: 2021-09-29 11:29:18
 * @Description:
 */
import IonSwitch from './src/ion-switch.vue';

IonSwitch.install = function install(_vue) {
  _vue.component(IonSwitch.name, IonSwitch);
};
export default IonSwitch;
